import { db } from "@/helpers/firebase/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";
import { Stripe } from "stripe";
import { Collections } from "@/helpers/utils/collections";
import { Price, Product } from "@stripe/firestore-stripe-payments";
import { DocumentData } from "firebase-admin/firestore";
import { Customer } from "@/models/user";

let stripe: Stripe;
const apiKey = process.env.STRIPE_SECRET_KEY;
if (apiKey) {
  stripe = new Stripe(apiKey, { apiVersion: '2026-07-29.dahlia' });
}

export async function getProductByName(pass: string): Promise<Product> {
  let result: Product = {
    name: pass,
    description: "",
    images: [],
    metadata: {},
    id: "",
    active: true,
    role: "",
    prices: [],
  };

  // find product id
  const productsRef = collection(db, Collections.STRIPE.PRODUCTS);
  let q = query(
    productsRef,
    where("name", "==", pass),
    where("active", "==", true),
    limit(1)
  );
  let querySnapshot = await getDocs(q);
  if (!querySnapshot.docs) {
    return result;
  }

  result = {
    ...querySnapshot.docs[0].data(),
    id: querySnapshot.docs[0].id,
  } as Product;

  // find price id
  const pricesRef = collection(
    db,
    Collections.STRIPE.PRODUCTS,
    result.id,
    Collections.STRIPE.PRICES
  );
  q = query(pricesRef);
  querySnapshot = await getDocs(q);
  let queryResult: DocumentData[] = [];
  querySnapshot.forEach((doc) =>
    queryResult.push({ ...doc.data(), id: doc.id })
  );
  if (!queryResult) {
    return result;
  }
  result = { ...result, prices: queryResult as Price[] };
  return result;
}

export async function getProducts(): Promise<Product[]> {
  const productsRef = collection(db, Collections.STRIPE.PRODUCTS);
  const q = query(productsRef, where("active", "==", true));
  const querySnapshot = await getDocs(q);

  const products: Product[] = await Promise.all(
    querySnapshot.docs.map(async (doc) => {
      let product = { ...doc.data(), id: doc.id } as Product;
      const pricesRef = collection(
        db,
        Collections.STRIPE.PRODUCTS,
        doc.id,
        Collections.STRIPE.PRICES
      );
      const q = query(
        pricesRef,
        where("description", "==", "default"),
        limit(1)
      );
      const pricesSnapshot = await getDocs(q);
      let queryResult: DocumentData[] = [];
      pricesSnapshot.forEach((doc) =>
        queryResult.push({ ...doc.data(), id: doc.id })
      );
      return { ...product, prices: queryResult as Price[] };
    })
  );

  return products;
}

export async function CheckIfAlreadyBought(
  productId: string,
  userDocumentId?: string
) {
  if (!userDocumentId) {
    return true;
  }
  const passesRef = collection(
    db,
    Collections.USERS,
    userDocumentId,
    Collections.PASSES
  );

  const q = query(passesRef, where("productId", "==", productId), limit(1));
  const result = await getDocs(q);
  return !result.empty;
}

export async function getCustomerIdFromUID(uid: string) {
  const docRef = doc(db, Collections.CUSTOMERS, uid);
  const result = await getDoc(docRef);
  if (!result.exists()) {
    return "";
  }
  return (result.data() as Customer).stripeId;
}
